import { GridItemDimensions, GridState } from "./grid";

/**
 * Creates a clone of an HTMLElement and find the actual width/height when it's not previously set.
 * @param item 
 * @param style Optional width/height to calculate the other width/height property from
 * @returns 
 */
export function cloneWidthHeight(item: HTMLElement, style: { width?: string, height?: string } = {}): GridItemDimensions {
  let clone = <HTMLElement>item.cloneNode(true);
  clone.style.position = 'absolute;'
  clone.style.top = '-9999px';
  clone.style.left = '-9999px';
  clone.style.opacity = '0';
  clone.style.width = style.width ?? '';
  clone.style.height = style.height ?? '';
  clone.classList.remove('gridded');
  item.parentNode.insertBefore(clone, item.nextSibling);
  let itemDimensions: GridItemDimensions = {
    width: clone.offsetWidth,
    height: clone.offsetHeight
  }
  clone.parentNode.removeChild(clone);
  return itemDimensions;
};


/**
 * Calculate pixel value from vw
 * @param vwValue 
 * @returns 
 */
export function pxFromVw(vwValue = 0): number {
  let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  return (vwValue * w) / 100;
}


/**
 * @param a State A
 * @param b State B
 * @returns true if equal, false if not
 */
export function compareStates(a: GridState, b: GridState): boolean {
  for (let ka in a) {
    if (a[ka] !== b[ka] && (!Number.isNaN(a[ka]) || !Number.isNaN(b[ka]))) {
      return false;
    }
  }
  for (let kb in b) {
    if (a[kb] !== b[kb] && (!Number.isNaN(a[kb]) || !Number.isNaN(b[kb]))) {
      return false;
    }
  }
  return true;
}